import { render } from "./ListeBlacklist.vue?vue&type=template&id=35b46913&ts=true"
import script from "./ListeBlacklist.vue?vue&type=script&lang=ts"
export * from "./ListeBlacklist.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__